<template>
  <van-tabs v-model:active="active" swipeable>
    <van-tab v-for="(tab, index) in tabs" :key="index" :title="tab.title">
      <component :is="tab.component" />
    </van-tab>
  </van-tabs>
</template>

<script setup>
import { ref } from 'vue';

// 定义不同的组件

import UserGuide from '@/components/UserGuide.vue';
import WordBook from '@/components/WordBook.vue';
import WalkMan from '@/components/WalkMan.vue';
import DictationWord from '@/components/DictationWord.vue';
import SpellWord from '@/components/SpellWord.vue';
import TestWord from '@/components/TestWord.vue';

// 继续导入其他组件...

const active = ref(0);

// 定义标签的标题和对应的组件
const tabs = [
  { title: '新手引导', component: UserGuide },
  { title: '单词本', component: WordBook },
  { title: '随身听', component: WalkMan },
  { title: '听写', component: DictationWord },
  { title: '拼词', component: SpellWord },
  { title: '测试', component: TestWord },
  
  // 继续添加其他标签和组件...
];

</script>
  
  <style>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    width: 95%;
    
    
  }

  :root:root {
    --van-tabs-line-height: 1rem;
    --van-tab-font-size: 0.4rem;
    --van-tab-line-height: 1rem;
    
}











  </style>